module.exports = __webpack_public_path__ + "img/icon_tap_07_b.a5af3eb7.svg";